var _defs, _rect, _circle, _rect2, _text, _text2, _rect3, _text3, _rect4, _rect5, _rect6, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverBackendCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 760,
    viewBox: "0 0 1200 760",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Backend commerce architecture",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1e293b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f97316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fbbf24"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 760,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1060,
    cy: 120,
    r: 200,
    fill: "#f97316",
    opacity: 0.18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 110,
    width: 1020,
    height: 540,
    rx: 30,
    fill: "#0b1220",
    stroke: "#f97316",
    strokeOpacity: 0.45
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 210,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 46,
    fontWeight: 800
  }, "COMMERCE BACKEND")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 250,
    fill: "#cbd5e1",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Catalog, cart, checkout, transaction flow")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 320,
    width: 500,
    height: 74,
    rx: 14,
    fill: "url(#ac)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 367,
    fill: "#111827",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 800,
    textAnchor: "middle"
  }, "Node.js  TypeScript  JWT")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 430,
    width: 320,
    height: 18,
    rx: 9,
    fill: "#475569"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 466,
    width: 420,
    height: 18,
    rx: 9,
    fill: "#475569"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 502,
    width: 270,
    height: 18,
    rx: 9,
    fill: "#475569"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 585,
    fill: "#f8fafc",
    fontFamily: "Segoe UI, Arial, sans-serif",
    fontSize: 24
  }, "Express/Nest, MongoDB, Payment integration")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverBackendCommerce);
export default __webpack_public_path__ + "static/media/cover-backend-commerce.b19ebd584631e90b1e349ee508bd240d.svg";
export { ForwardRef as ReactComponent };